import Validate from "../../services/validate-service/Validate";

export default class Utils {
    static updateOrganizationName = (event, values) => {
        const value = event.target.value;
        const miniAppDeepClone = JSON.parse(JSON.stringify(values));
        miniAppDeepClone.organization.name = value;
        return miniAppDeepClone;
    };

    static updateCredential = (event, values) => {
        const value = event.target.value;
        const miniAppDeepClone = JSON.parse(JSON.stringify(values));
        miniAppDeepClone.credential[event.target.name] = value;
        return miniAppDeepClone;
    };

    static updateRevision = (event, values) => {
        const value = event.target.value;
        const miniAppDeepClone = JSON.parse(JSON.stringify(values));
        miniAppDeepClone.revisions[0][event.target.name] = value;
        return miniAppDeepClone;
    };

    static loadIcon = (event, values, image_default) => {
        const name = event.target.name;
        const value = event.target.src;
        let miniAppDeepClone = JSON.parse(JSON.stringify(values));
        miniAppDeepClone[name] = value ? value : image_default;
        return miniAppDeepClone;
    };

    static isValidForRegister = miniApp => {
        const miniAppDeepClone = JSON.parse(JSON.stringify(miniApp));
        return (
            Validate.isValidIcon(miniAppDeepClone.icon) &&
            Validate.checkBasicInputs(miniAppDeepClone) &&
            Validate.isValidMiniappTarget(miniApp)
        );
    };
}
